<template>
    <tr class="lms__superadmin_customer_edit_emailsenders_table_item">
        <td class="lms__superadmin_customer_edit_emailsenders_table_emailaddress">{{senderEmailAddress}}</td>
        <td class="lms__superadmin_customer_edit_emailsenders_table_status">
            <component-status :status="senderStatus"/>
        </td>
        <td class="lms__superadmin_customer_edit_emailsenders_table_actions">
            <div class="columns is-variable">
                <div class="column"></div>
                <template v-if="senderStatus === 'created'">
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-customer-edit-email-senders-table-item-verify-action'"
                            :theme="'default'"
                            :animate-loading="true"
                            :animate-loading-event-name="'sender-verify'"
                            @click="verifyEmailSender"
                        >Verify
                        </component-button>
                    </div>
                </template>
                <template v-if="senderStatus === 'pending_verification'">
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-customer-edit-email-senders-table-item-test-action'"
                            :theme="'default'"
                            :animate-loading="true"
                            :animate-loading-event-name="'sender-test'"
                            @click="testEmailSender"
                        >Test
                        </component-button>
                    </div>
                </template>
                <template v-if="senderStatus === 'verified'">
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-customer-edit-email-senders-table-item-make-default-action'"
                            :disabled="senderIsDefault"
                            :animate-loading="true"
                            :animate-loading-event-name="'sender-make-default'"
                            v-on="senderId ? { 'click' : setDefaultEmailSender } : { 'click' : restoreDefaultEmailSender }"
                        >{{ senderIsDefault ? 'Default' : 'Make default' }}
                        </component-button>
                    </div>
                </template>
                <template v-if="senderId">
                    <div class="column is-narrow">
                        <component-button-menu
                            :buttons="[
                                {
                                    key: 'remove-sender',
                                    name: 'Remove sender'
                                }
                            ]"
                            @emit-remove-sender="removeEmailSender"
                        ></component-button-menu>
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>

import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'

export default {
  name: 'lms-superadmin-customer-edit-email-senders-table-item',
  components: { ComponentButtonMenu, ComponentButton, ComponentStatus },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    senderEmailAddress () {
      return this.item.emailAddress
    },
    senderStatus () {
      return this.item.status
    },
    senderId () {
      return this.item.id
    },
    senderIsDefault () {
      return this.defaultSenderEmailAddress === this.senderEmailAddress
    },
    defaultSender () {
      return this.$store.getters.getLmsSuperadminCustomerEmailSendersDefault
    },
    defaultSenderId () {
      return this.defaultSender ? this.defaultSender.id : undefined
    },
    defaultSenderEmailAddress () {
      return this.defaultSender ? this.defaultSender.emailAddress : undefined
    }
  },
  methods: {
    verifyEmailSender () {
      this.$store.dispatch('lmsSuperadminCustomerEmailSendersVerify', this.senderId).then(() => {
        this.$emit('emit', { message: 'emit-perform-get-items' })
      }).finally(() => {
        this.$eventBus.$emit('stop-sender-verify')
      })
    },
    testEmailSender () {
      this.$store.dispatch('lmsSuperadminCustomerEmailSendersTest', this.senderId).then(() => {
        this.$emit('emit', { message: 'emit-perform-get-items' })
      }).finally(() => {
        this.$eventBus.$emit('stop-sender-test')
      })
    },
    setDefaultEmailSender () {
      this.$store.dispatch('lmsSuperadminCustomerEmailSendersSetDefault', this.senderId).then(() => {
        this.$emit('emit', { message: 'emit-perform-get-items' })
      }).finally(() => {
        this.$eventBus.$emit('stop-sender-make-default')
      })
    },
    restoreDefaultEmailSender () {
      this.$store.dispatch('lmsSuperadminCustomerEmailSendersUnsetDefault', this.defaultSenderId).then(() => {
        this.$emit('emit', { message: 'emit-perform-get-items' })
      }).finally(() => {
        this.$eventBus.$emit('sender-make-default')
      })
    },
    removeEmailSender () {
      this.$store.dispatch('lmsSuperadminCustomerEmailSendersRemove', this.senderId).then(() => {
        this.$emit('emit', { message: 'emit-perform-get-items' })
      })
    }
  }
}
</script>
